import React, {useEffect, useState, useCallback} from 'react';
import {setExplorePersonSelected} from 'actions/index.js';
import { connect } from "react-redux";
import Person from './Person.js';
import {fetchPeople} from './fetchPeople.js';
import ethereum from 'decentralized/ethereum.js';

const People = ({personSelected, setPersonSelected, allSequences}) => {
    const [people, setPeople] = useState([]);

    useEffect(() => {
        fetchPeople(allSequences).then(
            people => setPeople(people));
    }, [setPeople, allSequences]);

    let personSelectedComponent = '';
    if (personSelected) {
        personSelectedComponent = (
            <Person
              onClick={() => setPersonSelected(undefined)}
              selected={true} person={personSelected}/>
        );
    }
    return (
        <div className="people">
          {personSelectedComponent}
          <div className="people-to-choose">
            {people
             .filter(person => !personSelected ||
                     personSelected.id !== person.id)
             .map(
                person =>
                    <Person
                      onClick={() => setPersonSelected(person)}
                      key={person.id}
                      person={person}/>)}
          </div>
        </div>
    );
}
const mapDispatchToProps = dispatch => {
    return {
        setPersonSelected : id => dispatch(setExplorePersonSelected(id))
    };
};

const mapStateToProps = (state, props) => {
    return {
        personSelected: state.explore.personSelected,
        allSequences: state.explore.allSequences
    }
};
 
export default connect(mapStateToProps, mapDispatchToProps)(People);


